import 'bootstrap/dist/css/bootstrap.min.css';
import { injectGlobal } from 'styled-components';

injectGlobal`

  .slick-next:before, .slick-prev:before {
    color: #555;
  }


`;



// WEBPACK FOOTER //
// ./src/assets/styles/application.js